/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { PricesStatusManager } from '../services/manager';
import { priceActions } from './definition';
import { getSlotAllPrices } from '../services/field';
import { ISlotPrice } from '../interfaces/field';

function priceIsLoading() {
    return {
        type: priceActions.PRICES_IS_LOADING,
    };
}

const priceReset = () => {
    return {
        type: priceActions.PRICES_RESET,
    };
};

function priceError(e: string) {
    return {
        type: priceActions.PRICES_ERROR,
        error: e,
        data: e,
    };
}

function priceSet(prices: any) {
    return {
        type: priceActions.PRICES,
        data: prices,
    };
}

/**
 * Reducer to rest a prices
 * @param values Data to reset prices
 */
export const resetStatePrice = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(priceReset());
    };
};

/**
 * Reducer to rest a prices
 * @param values Data to reset prices
 */
export const resetPriceReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(priceReset());
    };
};

/**
 * Reducer to reset Prices
 * @param values Values to reset prices
 */
export const resetPrice = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(priceReset());
    };
};

/**
 * Reducer to get a price by id
 * @param id Id of price to find
 */
export const getSlotPrices = (values: ISlotPrice) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(priceIsLoading());
        try {
            const response = await getSlotAllPrices(values);
            if (response?.statusCode === PricesStatusManager.FIELD_SLOTS_PRICES && response.data) {
                //console.log('aqui', response)
                dispatch(priceSet(response));
            } else {
                dispatch(priceError('Could not get price'));
            }
        } catch (error: any) {
            dispatch(priceError('No se pudo obtener el price'));
        }
    };
};
